<template>
  <div id="FAQAdmin">
    <main>
      <div class="page-header pb-10 page-header-dark bg-gradient-primary-to-secondary">
        <div class="container-fluid">
          <div class="page-header-content">
            <h1 class="page-header-title">
              <div class="page-header-icon">
                <i data-feather="activity"></i>
              </div>
              <span>FAQs</span>
            </h1>
            <div class="page-header-subtitle"></div>
          </div>
        </div>
      </div>
      <div class="container-fluid mt-n10">
        <div class="row" v-show="showList">
          <div class="col-md-12">
            <div class="card mb-4">
              <div class="card-body">
                <div class="accordion" id="accordionExample">
                  <div class="card" v-for="(item, index) in faqs" :key="index">
                    <div class="card-header" :id="'heading'+index">
                      <h2 class="mb-0">
                        <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" :data-target="'#collapse'+index" aria-expanded="true" :aria-controls="'collapse'+index">
                          <b>{{item.question}}</b>
                        </button>
                      </h2>
                    </div>

                    <div :id="'collapse'+index" class="collapse" :aria-labelledby="'heading'+index" data-parent="#accordionExample">
                      <div class="card-body">
                        <div v-html="item.answer"></div>
                        <EditForm :faqIndex="index" :faqObject="item" v-if="editFormIndex==index" @hideBack="hideEditForm"></EditForm>
                        <DeleteFAQ :faqIndex="index" :faqObject="item" v-if="deleteFaqIndex==index" @deleted="hideDeleteFAQ"></DeleteFAQ>
                      </div>
                      <button class="btn btn-xs" @click="showEditForm(index)">Edit</button>
                      <button class="btn btn-xs" @click="showDeleteFAQ(index)">Delete</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="card mb-4">
              <div class="card-body">
                <!-- create for -->
                <CreateForm @newFAQ="newFAQ"></CreateForm>
                <!-- create for -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import axios from "axios";
import EditForm from "./EditForm";
import CreateForm from "./CreateForm";
import DeleteFAQ from "./DeleteFAQ";

export default {
  name: "FAQAdmin",

  data() {
    return {
      faqs: [],
      showList: false,
      editFormIndex: -1,
      deleteFaqIndex: -1
    };
  },

  mounted() {
    axios.get("/admin/faqs").then(res => {
      if (res.data.status == "success") {
        this.faqs = res.data.faqs;
        this.showList = true ? res.data.faqs.length > 0 : false;
      }
    });
  },

  methods: {
    newFAQ(newFAQ) {
      this.faqs.push(newFAQ);
      this.showList = true;
    },

    showEditForm(index) {
      this.editFormIndex = index;
    },

    hideEditForm(obj) {
      this.editFormIndex = -1;
      this.faqs[obj.updatedFaqIndex].answer = obj.updatedFaqObj.answer;
      this.faqs[obj.updatedFaqIndex].question = obj.updatedFaqObj.question;
    },

    showDeleteFAQ(index) {
      this.deleteFaqIndex = index;
      //console.log(index);
    },

    hideDeleteFAQ(obj) {
      this.deleteFaqIndex = -1;
      this.faqs.splice(obj.deletedFaqIndex, 1);
    }
  },

  computed: {
    authUser() {
      return this.$store.state.authUser;
    },
    client() {
      return this.$store.state.client;
    }
  },

  components: {
    CreateForm,
    DeleteFAQ,
    EditForm
  }
};
</script>